// useNodeForms.js

import { useEffect, useState } from 'react';

import { subscribeToForms } from 'services/forms/FormReadService';
import { DEFAULT_FORM_KEY } from 'services/forms/FormModel';

function normalizeString(value) {
  return typeof value === 'string' ? value.trim() : '';
}

/**
 * Subscribes to form templates for a base node type.
 */
export default function useNodeForms({ baseKey, typeKey } = {}) {
  const [forms, setForms] = useState([]);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const cleanedBaseKey = normalizeString(baseKey);
    const cleanedTypeKey = normalizeString(typeKey);

    if (!cleanedBaseKey || !cleanedTypeKey) {
      setForms([]);
      setIsReady(true);
      return undefined;
    }

    setIsReady(false);

    return subscribeToForms({
      typeKey: cleanedTypeKey,
      baseKey: cleanedBaseKey,
    }, (nextForms) => {
      setForms(Array.isArray(nextForms) ? nextForms : []);
      setIsReady(true);
    });
  }, [typeKey, baseKey]);

  const defaultForm = forms.find((form) => form.isDefault || form.key === DEFAULT_FORM_KEY) || forms[0] || null;

  return {
    defaultForm,
    forms,
    isReady,
  };
}
